export default "__VITE_ASSET__D1O10s97__"